import { generateTestId } from "@client-shared";

export const setOrdersFilterBarTestId = (identifier: string): string => generateTestId("OrdersFilterBar", identifier);

export const setOrdersFilterBarContainerTestId = (): string => setOrdersFilterBarTestId("container");

export const setOrdersFilterBarSearchInputTestId = (): string => setOrdersFilterBarTestId("search-input");

export const setOrdersFilterBarStatusButtonTestId = (filterKey: string): string => setOrdersFilterBarTestId(`status-${filterKey}`);

export const setOrdersFilterBarSearchClearTestId = (): string => setOrdersFilterBarTestId("search-clear");

export const setOrdersFilterBarStatusCountTestId = (filterKey: string): string => setOrdersFilterBarTestId(`status-${filterKey}-count`);

export const setOrdersFilterBarStatusCountSkeletonTestId = (filterKey: string): string =>
  setOrdersFilterBarTestId(`status-${filterKey}-count-skeleton`);
